export default __webpack_public_path__ + "static/media/hadoop.4b9e7366.png";